import React from "react";
const TONES = {
    neutral: "bg-sunken border-line text-gray-600",
    success: "bg-success-soft border-transparent text-success",
    danger: "bg-danger-soft border-transparent text-danger",
    warning: "bg-warning-soft border-transparent text-warning",
    info: "bg-info-soft border-transparent text-info",
    brand: "bg-brand-50 border-brand-200 text-brand-700",
};
// Colour only reinforces the label, never replaces it — success stays green even against a pink brand tint.
export function Badge({ tone = "neutral", toneClass, icon, children, className, title }) {
    return (<span title={title} className={`
                inline-flex items-center gap-1 whitespace-nowrap rounded-full border px-2.5 py-0.5
                text-xs font-medium tabular-nums
                ${toneClass ?? TONES[tone]}
                ${className ?? ""}
            `}>
            {icon}
            {children}
        </span>);
}
export default Badge;
//# sourceMappingURL=badge.jsx.map